import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ecf999d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "col-12 col-lg-8 d-flex align-items-center justify-content-center flex-column mb-32 mb-lg-0"
}
const _hoisted_2 = { class: "h4 title fw-normal text-primary" }
const _hoisted_3 = { class: "h4 title mb-64 text-primary" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add me-12",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "col-12 col-lg-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!
  const _component_the_professional_consultation_update = _resolveComponent("the-professional-consultation-update")!
  const _component_the_professional_consultation_view = _resolveComponent("the-professional-consultation-view")!
  const _component_the_professional_consultation_create = _resolveComponent("the-professional-consultation-create")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.currentConsultation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('No hay niguna consulta seleccionada.')), 1),
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('Seleccione alguna o cree una nueva.')), 1),
          (_ctx.can('professional.expedient.consultation.store'))
            ? (_openBlock(), _createBlock(_component_v_button, {
                key: 0,
                variant: "secondary",
                class: "new-consultation",
                "aria-label": _ctx.$t('Nueva consulta'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalToShow = 'the-professional-consultation-create'))
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('Nueva consulta')), 1)
                ]),
                _: 1
              }, 8, ["aria-label"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.mode === 'edit')
            ? (_openBlock(), _createBlock(_component_the_professional_consultation_update, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.mode === 'view' && _ctx.currentConsultation && _ctx.canShowConsultation)
            ? (_openBlock(), _createBlock(_component_the_professional_consultation_view, {
                key: 1,
                onCreateConsultationRequested: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalToShow = 'the-professional-consultation-create'))
              }))
            : _createCommentVNode("", true)
        ])),
    (_ctx.modalToShow === 'the-professional-consultation-create')
      ? (_openBlock(), _createBlock(_component_the_professional_consultation_create, {
          key: 2,
          onClosed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalToShow = null))
        }))
      : _createCommentVNode("", true)
  ], 64))
}